import React, { useContext, useEffect, useState } from "react";
import clsx from "clsx";
import "./styles.scss";
import ProductContext from "../shared/contexts/ProductContext";
import CustomSwiper from "../shared/SwiperCustomComponent/CustomSwiper";
import { SwiperSlide } from "swiper/react";
import Image from "../shared/Image";

const ProductSwiper = (props) => {
  const context = useContext(ProductContext);
  const { filename, param } = props;
  const [tableData, setTableData] = useState([]);
  const userID = "3585269";
  const merchantId = "97366";
  const isShareUrl = true;

  useEffect(() => {
    const fetchData = async (skip) => {
      const response = await fetch(process.env.PUBLIC_URL + filename);
      const text = await response?.text();
      const lines = text?.trim()?.split("\n");
      const headers = lines?.[0]?.split("|");
      const data = lines?.slice(1)?.map((line) => line?.split("|"));
      let index = 0;
      const formattedData = data?.map((line) => {
        const row = {};
        headers?.forEach((header, i) => {
          index = skip + i;
          if (index < data?.length) {
            row[header] = line?.[index];
          }
        });
        return row;
      });

      if (lines?.[0]?.toLocaleLowerCase()?.includes("<!doctype html>")) {
        setTableData([]);
      } else {
        setTableData(formattedData);
      }
    };

    fetchData(0);
  }, [filename]);

  if (
    tableData === undefined ||
    (Array.isArray(tableData) && tableData?.length <= 0)
  ) {
    return <></>;
  }

  return (
    <div
      className={clsx(
        "ProductSwiper product-wrap swiper-listing-items",
        `product-${param}`
      )}
    >
      <div className="products-title">{param}</div>

      <CustomSwiper
        centeredSlides={false}
        className="small-items-layout"
        isBigItem={true}
        scrollbar={true}
        mousewheel={true}
      >
        {tableData?.map((item, index) => {
          const img = item?.["Image Url"];

          // const number = img?.split("/")?.[0];
          const link = isShareUrl
            ? `https://www.shareasale.com/m-pr.cfm?merchantID=${merchantId}&userID=${userID}&productID=${item?.Id}`
            : item?.link?.replaceAll("YOURUSERID", userID);
          const price = item?.Price;
          const Name = item?.Name;

          if (!price || !Name) {
            return <></>;
          }
          return (
            <SwiperSlide key={index}>
              <a
                key={index}
                target="_blank"
                rel="noreferrer"
                className="link-to-product"
                href={link}
              >
                <div className="item-image">
                  <Image allt={Name} src={img} />
                </div>
                <div className="data-list-wrap">
                  <div className="data-title">
                    <span>{Name}</span>
                  </div>
                  <div className="data-price">
                    <u>Price:</u> <span>{price}$</span>
                  </div>
                </div>
                <div className="checkout-btn">Check item</div>
              </a>
            </SwiperSlide>
          );
        })}
      </CustomSwiper>
    </div>
  );
};

export default ProductSwiper;
